<template>
  <HrApproval
    @click:sendHrApproval="emailMyCompany"
    @to:credit-check="toCreditCheckPage"
    :loading="sendingHRApproval"
    :disable="sendingHRApproval"
    :companyName="userProfile.companyName"
  />
</template>

<script>
import { getEnv } from 'ecx.saigon.ui.common';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'HrApprovalWidget',
  metaInfo: {
    title: 'HR Approval |'
  },
  computed: {
    ...mapState({
      quote: (state) => state.quote.quote || {},
      userProfile: (state) => state.user.user.profile,
      applicationMetaData: (state) =>
        state.application.application.metaData || {},
      sendingHRApproval: (state) => state.application.sendingHRApproval
    })
  },
  methods: {
    ...mapActions('application', ['sendHRApprovalRequest']),
    async emailMyCompany() {
      try {
        await this.sendHRApprovalRequest();
        await this.$router.push({
          name: this.$RouteNames.hrApprovalSent,
          params: { quoteId: this.quoteId }
        });
      } catch (err) {}
    },
    async toCreditCheckPage() {
      const env = await getEnv();
      window.location = env.VUE_APP_CREDIT_CHECK_ROUTE;
    }
  },
  mounted() {
    if (this.applicationMetaData.hrApprovalRequestSent) {
      this.$router.push({
        name: this.$RouteNames.hrApprovalSent,
        params: { quoteId: this.quote.quoteId }
      });
    }
  },
  components: {
    HrApproval: () => import('../../components/page/hr-approval')
  }
};
</script>
